import { render, staticRenderFns } from "./SystemParametersView.vue?vue&type=template&id=6f3493e3&scoped=true"
import script from "./SystemParametersView.vue?vue&type=script&lang=js"
export * from "./SystemParametersView.vue?vue&type=script&lang=js"
import style0 from "./SystemParametersView.vue?vue&type=style&index=0&id=6f3493e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3493e3",
  null
  
)

export default component.exports